<template>
  <div>
    <!-- Loading Spinner -->
    <loading :active.sync="isLoading"></loading>

    <!-- Page Title Section -->
    <div class="app-title">
      <div>
        <h1><i class="fas fa-tachometer-alt"></i> หน้าแรก</h1>
        <p>[{{ pageTitle }}]</p>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><a href="#">Home</a></li>
      </ul>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <h3>งานบริการ รายวัน</h3>
          <line-chart
            v-if="dailyChart"
            :chartData="dailyChart"
            :options="dailyChartOptions"
          />
        </div>
      </div>

      <div class="col-md-8">
        <div class="tile">
          <h3>งานบริการ แยกประเภท</h3>
          <bar-chart
            v-if="typeChart"
            :chartData="typeChart"
            :options="chartOptions"
          />
        </div>
      </div>

      <div class="col-md-4">
        <div class="tile">
          <h3>สถานะงาน</h3>
          <doughnut-chart
            v-if="statusChart"
            :chartData="statusChart"
            :options="chartOptions"
          />
        </div>
      </div>

      <div class="col-md-12">
        <div class="tile">
          <h3>งานบริการ รายเดือน</h3>
          <bar-chart
            v-if="monthlyChart"
            :chartData="monthlyChart"
            :options="chartOptions"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from "../components/LineChart.vue";
import BarChart from "../components/BarChart.vue";
import DoughnutChart from "../components/DoughnutChart.vue";

export default {
  components: {
    LineChart,
    BarChart,
    DoughnutChart,
  },

  data() {
    return {
      isLoading: false,
      pageTitle: this.$route.name,

      typeChart: null,
      dailyChart: null,
      monthlyChart: null,
      statusChart: null,

      chartOptions: {
        responsive: true,

        plugins: {
          legend: {
            position: "bottom",
          },
        },

        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0,
            },
          },
        },
      },

      dailyChartOptions: {
        responsive: true,
        maintainAspectRatio: false, // ใช้เฉพาะกราฟนี้

        plugins: {
          legend: {
            position: "bottom",
          },
        },

        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0,
            },
          },
        },
      },
    };
  },

  async mounted() {
    this.isLoading = true;

    try {
      const res = await this.$http.get("/dashboard");

      this.typeChart = res.data.type_chart;
      this.dailyChart = res.data.daily_chart;
      this.monthlyChart = res.data.monthly_chart;
      this.statusChart = res.data.status_chart;

      this.isDataLoaded = true;
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style scoped>
/* Optional styling for charts or other components */
.chart-box {
  position: relative;
  height: 350px;
}

.chart-sm {
  height: 280px;
}

.chart-md {
  height: 320px;
}

.chart-lg {
  height: 380px;
}
</style>
